import { render, staticRenderFns } from "./carouselNews1.vue?vue&type=template&id=638bbb12&scoped=true"
import script from "./carouselNews1.ts?vue&type=script&lang=ts&external"
export * from "./carouselNews1.ts?vue&type=script&lang=ts&external"
import style0 from "./carouselNews1.vue?vue&type=style&index=0&id=638bbb12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638bbb12",
  null
  
)

export default component.exports